"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var useConstCallback_1 = require("powerhooks/useConstCallback");
var useClickAway_1 = require("powerhooks/useClickAway");
var hooks_1 = require("evt/hooks");
var Icon_1 = require("./Icon");
var IconButton_1 = require("./IconButton");
var Search_1 = __importDefault(require("@material-ui/icons/Search"));
var Cancel_1 = __importDefault(require("@material-ui/icons/Cancel"));
var Icon = Icon_1.createIcon({
    "search": Search_1.default,
    "cancel": Cancel_1.default,
}).Icon;
var IconButton = IconButton_1.createIconButton({ Icon: Icon }).IconButton;
var useStyles = ThemeProvider_1.makeStyles()(function (theme, _a) {
    var isActive = _a.isActive;
    return ({
        "root": {
            "borderRadius": 8,
            "overflow": "hidden",
            "boxShadow": theme.shadows[1],
            "& > div": {
                "display": "flex",
                "alignItems": "center",
                "backgroundColor": theme.colors.useCases.surfaces.surface1,
                "cursor": isActive ? undefined : "pointer",
                "overflow": "hidden",
                "border": "solid 2px transparent",
                "&:hover": {
                    "borderBottomColor": theme.colors.useCases.buttons.actionActive,
                },
            },
        },
        "input": __assign(__assign({ "flex": 1, "caretColor": theme.colors.useCases.typography.textFocus }, theme.typography.variants["body 1"].style), { "outline": "none", "borderWidth": 0, "border": "none", "backgroundColor": "transparent", "color": theme.colors.useCases.typography.textPrimary, "&::placeholder": {
                "color": theme.colors.useCases.typography.textDisabled,
                "opacity": 1,
            } }),
        "icon": {
            "margin": theme.spacing(2) - 2 + "px " + (theme.spacing(3) - 2) + "px",
            "color": isActive
                ? theme.colors.useCases.typography.textFocus
                : undefined,
        },
        "searchLabel": __assign(__assign({}, theme.muiTheme.typography.button), { "display": "block", "flex": 1, "color": theme.colors.useCases.typography.textPrimary }),
    });
});
exports.SearchBar = react_1.memo(function (props) {
    var className = props.className, onSearchChange = props.onSearchChange, onKeyPress = props.onKeyPress, search = props.search, _a = props.placeholder, placeholder = _a === void 0 ? "Search" : _a, evtAction = props.evtAction;
    var _b = __read(react_1.useState(search !== ""), 2), isActive = _b[0], setIsActive = _b[1];
    var _c = useStyles({ isActive: isActive }), classes = _c.classes, cx = _c.cx;
    var onClearButtonClick = useConstCallback_1.useConstCallback(function () {
        var _a;
        onSearchChange("");
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    var onRootClick = useConstCallback_1.useConstCallback(function () { return setIsActive(true); });
    var onIconClick = useConstCallback_1.useConstCallback(function () {
        var inputEl = inputRef.current;
        if (inputEl === null)
            return;
        inputEl.focus();
        inputEl.setSelectionRange(0, search.length);
    });
    var onInputChange = useConstCallback_1.useConstCallback(function (event) {
        var value = event.target.value;
        onSearchChange(value);
    });
    var inputRef = react_1.useRef(null);
    var onInputKeyDown = useConstCallback_1.useConstCallback(function (event) {
        var _a;
        var key = (function () {
            switch (event.key) {
                case "Escape":
                case "Enter":
                    return event.key;
                default:
                    return "irrelevant";
            }
        })();
        if (key === "irrelevant") {
            return;
        }
        onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress(key);
        switch (key) {
            case "Enter":
                if (search === "") {
                    setIsActive(false);
                }
                break;
            case "Escape":
                onSearchChange("");
                setIsActive(false);
                break;
        }
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    });
    var rootRef = useClickAway_1.useClickAway(function () {
        if (search !== "")
            return;
        setIsActive(false);
    }).rootRef;
    hooks_1.useEvt(function (ctx) {
        return evtAction === null || evtAction === void 0 ? void 0 : evtAction.attach(function (action) { return action === "CLEAR SEARCH"; }, ctx, function () { return onInputKeyDown({ "key": "Escape" }); });
    }, [evtAction !== null && evtAction !== void 0 ? evtAction : Object]);
    return (jsx_runtime_1.jsx("div", __assign({ ref: rootRef, className: cx(classes.root, className), onClick: onRootClick }, { children: jsx_runtime_1.jsxs("div", { children: [jsx_runtime_1.jsx(Icon, { iconId: "search", onClick: onIconClick, className: classes.icon }, void 0),
                isActive ? (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("input", { ref: inputRef, autoFocus: true, className: classes.input, type: "text", value: search, onChange: onInputChange, onKeyDown: onInputKeyDown, spellCheck: false, placeholder: placeholder }, void 0),
                        jsx_runtime_1.jsx(IconButton, { iconId: "cancel", size: "small", disabled: search === "", onClick: onClearButtonClick }, void 0)] }, void 0)) : (jsx_runtime_1.jsx("span", __assign({ className: classes.searchLabel }, { children: placeholder }), void 0))] }, void 0) }), void 0));
});
//# sourceMappingURL=SearchBar.js.map